import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import {
  ComponentModalConfig,
  ModalSize,
  SuiModal,
} from '@richardlt/ng2-semantic-ui';
import { Subject } from 'rxjs';
interface IDocumentTypeModalContext {
  title: string;
  data: any;
}
@Component({
  selector: 'app-document-type-modal',
  templateUrl: './document-type-modal.component.html',
  styleUrls: ['./document-type-modal.component.scss'],
})
export class DocumentTypeModalComponent implements OnInit {
  private unsubscribe$: Subject<void> = new Subject<void>();
  formSubmitAttempt: boolean;
  success: any;
  error: any;
  pending: boolean;
  allTypes: Array<any> = [];
  selectedDocId: any;
  selected: any;
  constructor(
    @Inject(DOCUMENT) private document,
    private fb: FormBuilder,
    public modal: SuiModal<IDocumentTypeModalContext, void, void>
  ) {
    this.allTypes = modal.context.data;
  }

  ngOnInit(): void {}

  selectDoc(doc) {
    this.selectedDocId = doc['documentTypeId'];
    this.selected = doc;
  }
}

export class DocumentTypeModal extends ComponentModalConfig<
  IDocumentTypeModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Tiny) {
    super(DocumentTypeModalComponent, { title, data });

    this.isClosable = false;
    this.transitionDuration = 200;
    this.transition = 'slide left';
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
